var _ellipse, _ellipse2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarpanIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.00416,
  cy: 15.8945,
  rx: 8.00416,
  ry: 7.94671,
  fill: "url(#paint0_linear_1070_27071)"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.0076,
  cy: 7.94671,
  rx: 8.00416,
  ry: 7.94671,
  fill: "url(#paint1_linear_1070_27071)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.00342 8.00416C8.00342 3.58358 11.587 0 16.0076 0V15.836C16.0076 20.2565 12.424 23.8401 8.00342 23.8401V8.00416Z",
  fill: "url(#paint2_linear_1070_27071)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1070_27071",
  x1: 8.00416,
  y1: 7.94775,
  x2: 8.00416,
  y2: 23.8412,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1664A2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2C83FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1070_27071",
  x1: 16.0076,
  y1: 0,
  x2: 16.0076,
  y2: 15.8934,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E9F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0056A5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1070_27071",
  x1: 12.0055,
  y1: 0,
  x2: 12.0055,
  y2: 23.8401,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02EAFA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A7CEF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarpanIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/darpan_icon.db3df1290a96a09a7e1fff8ffb7e294d.svg";